import { DateTime } from 'ts-luxon';
import z from 'zod';
import { UserInformationSchema } from '../base';
import { EntitySchema, ProgressStatusEnum, ProgressStatus } from '../primitives';
import { EventsBaseIntegrationEventSchema } from './Base';

export const EventModelSchema = EntitySchema.extend({
    externalId: z.string(),
    owner: UserInformationSchema,
    name: z.string(),
    iocCountryCode: z.string(),
    timeZoneId: z.string(),
    beginDate: z.iso.date(),
    endDate: z.iso.date(),
    state: ProgressStatusEnum,
    seriesId: z.guid().nullish(),
    imageId: z.guid().nullish(),
    location: z.string().nullish(),
    lockedStructure: z.boolean(),
    resultsPublishedAtUtc: z.string().nullish(),
});

export const EventsIntegrationEventSchema = EventsBaseIntegrationEventSchema.extend({
    items: z.array(EventModelSchema),
});

//total equals the item count until the backend pages
export const EventSearchResultSchema = z.object({
    items: z.array(EventModelSchema),
    total: z.number(),
});

export type EventModel = z.infer<typeof EventModelSchema>;

export type EventSearchResult = z.infer<typeof EventSearchResultSchema>;

export type EventsCreatedEvent = z.infer<typeof EventsIntegrationEventSchema>;

export type EventsUpdatedEvent = z.infer<typeof EventsIntegrationEventSchema>;

export type EventsDeletedEvent = z.infer<typeof EventsIntegrationEventSchema>;

export const createDefaultEvent = (seriesId?: string): EventModel => {
    const today = DateTime.now().toISODate()!;
    return {
        id: '',
        externalId: '',
        owner: {
            userId: '',
            userEmail: '',
            userName: '',
        },
        name: '',
        iocCountryCode: '',
        timeZoneId: '',
        beginDate: today,
        endDate: today,
        state: ProgressStatus.Waiting,
        seriesId: seriesId,
        imageId: null,
        location: null,
        lockedStructure: false,
    };
};
